<template>
	<div
		class="loading-container"
		:class="$attrs.class"
		:style="loading ? $attrs.style : null"
	>
		<slot />
		<transition name="fade">
			<div v-if="loading" class="loading-inner">
				<div class="loading-bar">
					<div v-if="message">{{ message }}</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'Loading',
	inheritAttrs: false,
	props: {
		loading: {
			type: Boolean,
			default: false
		},
		message: {
			type: String,
			default: null
		}
	}
}
</script>
